var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-drawer'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('error-overlay'),_c('success-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }